import ActionState from 'app/enums/ActionState'

export default function(input){

    switch(input){

        case ActionState.PENDING: return 'Open';
        case ActionState.IN_PROCESS: return 'Ingepland';
        case ActionState.RESOLVED: return 'Afgehandeld door medewerker';
        case ActionState.CLOSED: return 'Afgesloten';
        case ActionState.ON_HOLD: return 'On hold';
        case ActionState.ACTION_PL: return 'Actie PL';
        default: return '';
    }
}